import { EventDispatcher, fadeIn, fadeOut, getNodeIndex, getTimeText, hideElement, l, last, qs, qsa, range } from '@utils/toolbox';
import { resultsRender } from '@components/resultsRender';
// TODO: move sorting field from class to dataSet

export const timetable = {
	selectedHashes: null,
	elems: {
		timetableElement: qs('#showresult-timetable'),
		loadingSpinner: qs('.loading-spinner__container')
	},
	isActive: false,
	init () {
		if (!js_params?.id) {
			return false;
		}

		this.selectedHashes = new Array(js_params.trips_count);
		this.handlebars();
		this.setupEvents();

		// TODO: can be removed?
		qs('ul.list-sort')?.remove?.();
	},
	clearHashes () {
		const hashes = this.selectedHashes;

		for (let i = 0; i < hashes.length; i++) {
			hashes[i] = null;
		}
	},
	show () {
		document.body.classList.add('show-timetable');
		timetable.isActive = true;
	},
	hide () {
		document.body.classList.remove('show-timetable');
		timetable.isActive = false;
		hideElement(this.elems.loadingSpinner);
	},
	handlebars () {
		Handlebars.registerHelper(
			{
				makeTop (index, trips) {
					const aircraftIcon = (index == 0) ? 'icon-circle-plane-up' : 'icon-circle-plane-down';
					const text = (index == 0) ? l('showresult.timeTable.chooseOutwardJourney', 'Välj utresa') : l('showresult.timeTable.chooseJourneyHome', 'Välj hemresa');

					let html = `
					<i class="icon ${ aircraftIcon }"></i>
					<span class="top-text">${ text }</span>
				`;

					if (trips == 1) {
						html += `
						<div class="abBtn abBtn-block abBtn--blueWhite expander">
							<span>${ l('showresult.timeTable.chooseAnotherTrip', 'Välj annan resa') }</span>
						</div>
					`;
					} else {
						html += `<span class="num-of-trips">${ trips } ${ l('global.simplePhrases.trips') }</span>`;
					}

					return html;
				},
				img (imgName) {
					return `/static/v${ js_params.version }/images/logos/${ imgName }.gif`;
				},
				formatPrice (price) {
					return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
				}
			});
	},
	missingAgencyImg (img) {
		img.innerHTML = '<span class="agency-text">' + img.title + '</span>';
	},
	allHashesSet () {
		return timetable.getBounds().every(index => !!timetable.selectedHashes?.[index]);
	},
	update () {
		const groupByMultiple = [];

		for (let i = 0; i < js_params.trips_count; ++i) {
			groupByMultiple.push({ index: i });
		}

		fadeIn(this.elems.loadingSpinner);

		// Ask Showresult to update the results accordingly
		EventDispatcher.dispatch('updateResults', {
			source: 'timetable',
			params: {
				filters: { alternativeHashes: timetable.selectedHashes },
				groupByMultiple: groupByMultiple,
				page: 0
			}
		});
	},
	setupEvents () {
		this.elems.timetableElement.addEventListener('click', (event) => {
			const target = event.target;
			// Select row
			if (target.closest('.timetable-result')) {
				const targetResult = target.closest('.timetable-result');
				const header = targetResult.closest('thead');

				if (header) {
					return;
				}


				const container = targetResult.closest('.table-container');
				const index = getNodeIndex(container);
				const hash = targetResult.dataset.hash;
				const isSelected = targetResult.classList.contains('selected');

				if (isSelected) {
					targetResult.classList.remove('selected');
					this.selectedHashes[index] = null;
				} else {
					targetResult.classList.add('selected');
					this.selectedHashes[index] = hash;
				}
				fadeOut(qs('.timetable-wrapper', this.elems.timetableElement));

				this.update();
				return;
			}

			// Table sort
			const targetTableSort = target.closest('.timetable .abTabNav__btn--sorter');

			if (targetTableSort) {
				qsa('.timetable .abTabNav__btn--sorter', target.closest('.timetable')).forEach((item) => {
					if (item !== targetTableSort) {
						item.classList.remove('desc');
						item.classList.remove('asc');
						item.classList.remove('abTabNav__btn--active');
					}
				});

				let reverse = false;
				const isAsc = targetTableSort.classList.contains('asc');
				const isDesc = targetTableSort.classList.contains('desc');

				if (isAsc) {
					targetTableSort.classList.remove('asc');
					targetTableSort.classList.add('desc');
					reverse = true;
				} else if (isDesc) {
					targetTableSort.classList.remove('desc');
					targetTableSort.classList.add('asc');
				} else {
					targetTableSort.classList.add('asc');
				}

				targetTableSort.classList.add('abTabNav__btn--active');

				let field = targetTableSort.classList.value;
				field = field.substr(field.indexOf('field-') + 6);
				field = field.split(' ');
				field = field[0];

				// Wrapped in qsa because we need to call .sort later and qsa will return an array
				const rows = qsa('.timetable-result', target.closest('.timetable'));
				this.sortRows(rows, field, reverse);
				return;
			}

			// Expander click
			const targetExpander = target.closest('.table-container .top .expander');
			if (targetExpander) {
				targetExpander.closest('.table-container').querySelector('.timetable-result.selected')?.click?.();
			}
		});

		// Hide results if there was an error
		EventDispatcher.addEventListener('showresult:requestResultUpdateError', ({ target }) => {
			if (target === 'timetable') {
				this.hide();
			}
		});

		// Show/hide timetable based on showresult view changes
		EventDispatcher.addEventListener('showresult:setActiveView', (target) => {
			if (target === 'timetable') {
				this.show();
				this.update();
			} else if (this.isActive) {
				this.hide();
			}
		});

		// Initiate result update request params on showresult demand
		EventDispatcher.addEventListener('showresult:requestResultUpdate', (data) => {
			if (!this.isActive || data.target !== 'timetable') {
				return;
			}
			this.update();
		});

		// Render new results when results have been updated from showresult (mostly due to filters update)
		EventDispatcher.addEventListener('showresult:resultsUpdated', (flights) => {
			if (!timetable.isActive) {
				return;
			}

			fadeOut(this.elems.loadingSpinner);

			// Check if at least one flight entry of results is empty
			const missingResults = flights.reduce((previous, current) => previous.length === 0 || current.length === 0, false);

			// Reset selection if results are missing
			if (missingResults) {
				this.clearHashes();
			}
			flights = flights.map(flight => resultsRender.getFlights(flight));

			// Render the view accordingly
			timetable.render(flights);
		});


		EventDispatcher.addEventListener('showresult:filtersReset', (activeView) => {
			if (!this.isActive || activeView !== 'timetable') {
				return;
			}
			this.clearHashes();
		});
	},
	sortRows (rows, field, reverse) {
		if (!rows.length) {
			console.warn('timetable.sortRows: no rows to sort');
			return;
		}
		const getField = function (elem, field) {
			return castToNumber(elem.querySelector(`.field-${field}`).dataset.field);
		};

		const castToNumber = function (value) {
			// By god it's a string scotty!
			if (Number.isNaN(+value)) {
				return value;
			} else {
				return +value;
			}
		};

		rows = rows.sort(function (a, b) {
			const valueA = getField(a, field);
			const valueB = getField(b, field);

			switch (typeof valueA) {
				case 'string':
					return valueA.localeCompare(valueB);
				case 'number':
					return valueA - valueB;
				default:
					return 1;
			}
		});

		const targetParent = rows[0].parentElement;

		if (reverse) {
			rows = rows.reverse();
		}

		// target.append(rows);
		const docFrag = document.createDocumentFragment();
		for (let i = 0; i < rows.length; i++) {
			docFrag.appendChild(rows[i]);
		}

		targetParent.appendChild(docFrag); // Appends all divs at once
	},
	getBounds (flights) {
		return range(0, js_params.trips_count - 1);
	},
	render (flightGroups) {
		fadeOut(qs('.timetable-wrapper', this.elems.timetableElement));

		const result = [];

		for (let i = 0; i < flightGroups.length; ++i) {
			const group = flightGroups[i];

			const data = timetable.getNboundData(group, i);

			result.push(data);
		}

		const wrapper = {
			bounds: result,
			isReturn: js_params.returntrip === 1,
			source: 'timetable'
		};

		const html = Handlebars.templates.timetable(wrapper);

		this.elems.timetableElement.innerHTML = html;

		// Draw selected result

		if (timetable.allHashesSet()) {
			const row = flightGroups[0][0];
			timetable.currentRow = row;

			resultsRender.response.flights = [row];

			resultsRender.render([row], 0, qs('.results-wrapper', this.elems.timetableElement), 'timetable');
		}

		// Update selected

		timetable.selectedHashes.forEach(function (hash, i) {
			if (hash) {
				const container = qsa('#showresult-timetable .table-container')?.[i];
				if (!container) {
					return;
				}
				const elem = container.querySelector(`[data-hash='${hash}']`);
				if (elem) {
					elem.classList.add('selected');
					container.scrollTo({ top: elem.offsetTop, behavior: 'smooth' });
				}
			}
		});

		// sort
		this.elems.timetableElement.querySelectorAll('.sort.field-departure').forEach(item => item.click());
	},
	getNboundData (group, index) {
		const result = [];

		for (let i = 0; i < group.length; ++i) {
			const flight = group[i];

			if (flight == 'undefined' || flight == null) {
				return;
			}

			const data = timetable.getRowData(flight, index);

			result.push(data);
		}

		return result;
	},
	getRowData (flight, index) {
		const alt = flight.trips[index];
		const lastSegment = last(alt.segments);

		const obj = {
			hash: alt.hash,
			price: flight.agents[0].price,
			traveltime: alt.traveltime,
			traveltimeText: getTimeText(alt.traveltime),
			segments: alt.segments,
			numStops: alt.segments.length - 1,
			departure: resultsRender.getAirport(alt.segments[0].departureAirport),
			departureIATA: alt.segments[0].departureAirport,
			departureTime: resultsRender.getDisplayTime(alt.segments[0].departureDate),
			departureDate: alt.segments[0].departureDate,
			arrival: resultsRender.getAirport(lastSegment.arrivalAirport),
			arrivalIATA: lastSegment.arrivalAirport,
			arrivalTime: resultsRender.getDisplayTime(lastSegment.arrivalDate),
			arrivalDate: lastSegment.arrivalDate,
			agent: flight.agents[0].agent,
			code: flight.agents[0].code
		};

		return obj;
	}
};

window.missingAgencyImg = timetable.missingAgencyImg;
window.timetable = timetable;
